import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ChartModule} from 'angular-highcharts';
import { ReportsComponent } from './reports.component';
import { ReportsRoutingModule } from './reports-routing.module';
import { NurseSummaryComponent } from './inpatient/nurse-summary/nurse-summary.component';
import { SmtSharedModule } from '../../../shared/module/shared.module'
import { DailyChurnRateReportComponent } from './shared/daily-churn-rate-report/daily-churn-rate-report.component';
import { DailyChurnRatePageComponent } from './acuity/daily-churn-rate-report/daily-churn-rate-page.component';
import { MeasuresReportComponent } from './shared/measures-report/measures-report.component';
import { ReasonsForVarianceReportComponent } from './shared/reasons-for-variance-report/reasons-for-variance-report.component';
import { ReasonsForVariancePageComponent } from './shared/reasons-for-variance-report/reasons-for-variance-page.component';
import { MeasuresPageComponent } from './acuity/measures-report/measures-page.component';
import { ReportService } from 'src/shared/services/report.service';
import { ReportFilterComponent } from 'src/shared/Baseclasses/report-filter.component';
import { PerformanceReportComponent } from './shared/performance/performance-report.component';
import { PerformancePageComponent } from './acuity/performance/performance-page.component';
import { ShiftBlockService } from 'src/shared/services/shift-block.service';
import { ReasonsForVarianceDrillDownReportComponent } from './shared/reasons-for-variance-drilldown-report/reasons-for-variance-drilldown-report.component';
import { ReasonsForVarianceDrillDownPageComponent } from './acuity/reasons-for-variance-drilldown-report/reasons-for-variance-drilldown-page.component';
import { AcuityTrendsReportComponent } from './shared/acuity-trends-report/acuity-trends-report.component';
import { AcuityTrendsPageComponent } from './acuity/acuity-trends-report/acuity-trends-page.component';
import { AcuitySummaryComponent } from './acuity/acuity-summary/acuity-summary.component';
import { InpatientChurnRatePageComponent } from './inpatient/churn-rate-report/inpatient-churn-rate-page.component';
import { InpatientPerformancePageComponent } from './inpatient/performance/inpatient-performance-page.component';
import { InpatientMeasuresPageComponent } from './inpatient/measures-report/inpatient-measures-page.component';
import { InpatientReasonsForVarianceDrillDownPageComponent } from './inpatient/reasons-for-variance-drilldown-report/inpatient-reasons-for-variance-drilldown-page.component';
import { TotalUosSummaryComponent } from './total-uos/total-uos-summary/total-uos-summary.component';
import { TotalUosTrendsPageComponent } from './total-uos/total-uos-trends-report/total-uos-trends-report-page.component';
import { TotalUosTrendsReportComponent } from './shared/total-uos-trends-report/total-uos-trends-report.component';
import { TotalUosReasonsForVarianceDrillDownPageComponent } from './total-uos/reasons-for-variance-drilldown-report/total-uos-reasons-for-variance-drilldown-page.component';
import { TotalUosMeasuresPageComponent } from './total-uos/measures-report/total-uos-measures-page.component';
import { TotalUosPerformancePageComponent } from './total-uos/performance/total-uos-performance-page.component';
import { ReportExportComponent } from 'src/shared/Baseclasses/report-export.component';
import { ExecutiveVariancePageComponent } from './executive-variance/executive-variance-page.component';
import { ExecutiveVarianceReportComponent } from './shared/executive-variance-report/executive-variance-report.component';

@NgModule({
  declarations: [
    DailyChurnRatePageComponent,
    DailyChurnRateReportComponent,
    InpatientChurnRatePageComponent,
    InpatientMeasuresPageComponent,
    InpatientPerformancePageComponent,
    InpatientReasonsForVarianceDrillDownPageComponent,
    NurseSummaryComponent,
    PerformancePageComponent,
    PerformanceReportComponent,
    ReasonsForVarianceReportComponent,
    ReasonsForVariancePageComponent,
    ReportFilterComponent,
    ReportsComponent,
    MeasuresPageComponent,
    MeasuresReportComponent,
    ReasonsForVarianceDrillDownReportComponent,
    ReasonsForVarianceDrillDownPageComponent,
    AcuityTrendsReportComponent,
    AcuityTrendsPageComponent,
    AcuitySummaryComponent,
    TotalUosSummaryComponent,
    TotalUosTrendsPageComponent,
    TotalUosTrendsReportComponent,
    TotalUosMeasuresPageComponent,
    TotalUosPerformancePageComponent,
    TotalUosReasonsForVarianceDrillDownPageComponent,
    ReportExportComponent,
    ExecutiveVariancePageComponent,
    ExecutiveVarianceReportComponent
  ],
  imports: [
    ReportsRoutingModule,
    ChartModule,
    CommonModule,
    FormsModule,
    InfiniteScrollModule,
    SmtSharedModule
  ],
  providers: [
    ReportService,
    ShiftBlockService
  ]
})
export class ReportsModule { }

